import { render, staticRenderFns } from "./pointLine.vue?vue&type=template&id=5a0f96d8&scoped=true&"
import script from "./pointLine.vue?vue&type=script&lang=js&"
export * from "./pointLine.vue?vue&type=script&lang=js&"
import style0 from "./pointLine.vue?vue&type=style&index=0&id=5a0f96d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0f96d8",
  null
  
)

export default component.exports